import type { PilotFramework } from "./pilotRequestsApi"

export type Association = { partNumber: string; framework: PilotFramework }
export function normalizedPart(part: string, issuer = "") {
  return issuer === "harting.com" ? part.replace(/\s/g, "") : part.trim()
}
export function associationKey(matches: Association[], issuer = "") {
  return JSON.stringify(
    [
      ...new Set(
        matches.map((m) =>
          JSON.stringify([m.framework, normalizedPart(m.partNumber, issuer)]),
        ),
      ),
    ].sort(),
  )
}
export function ReviewAssociations({ matches }: { matches: Association[] }) {
  const frameworks = [...new Set(matches.map((m) => m.framework))]
  return (
    <div className="space-y-1">
      {frameworks.map((framework) => (
        <p key={framework}>
          {framework.toUpperCase()}:{" "}
          {[
            ...new Set(
              matches
                .filter((m) => m.framework === framework)
                .map((m) => m.partNumber),
            ),
          ].join(", ")}
        </p>
      ))}
    </div>
  )
}
export const reviewStatusKeys = {
  pending: "CI_REVIEW_PENDING",
  approved: "CI_REVIEW_APPROVED",
  rejected: "CI_REVIEW_REJECTED",
} as const
